import { createFileRoute, redirect } from '@tanstack/react-router';
import { DashboardPage } from '@/features/dashboard/dashboard-page';
import { requireAuthenticatedUser } from '@/lib/route-guards';
import { useExtensionsStore } from '@/stores/extensions';

export const Route = createFileRoute('/dashboard')({
  beforeLoad: async () => {
    await requireAuthenticatedUser();

    // While the `home-dashboard` extension is off, a bookmarked /dashboard goes
    // quietly to People rather than announcing a feature that is switched off —
    // this is the ship-dark path, and dark means not advertised either.
    const store = useExtensionsStore.getState();
    if (!store.isLoaded) await store.load();
    if (!useExtensionsStore.getState().isExtensionEnabled('home-dashboard')) {
      throw redirect({ to: '/people' });
    }
  },
  component: DashboardPage,
});
